import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export const HeroSection = () => {
  const bullets = ['Sin meditación', 'Sin pastillas', 'Sin fuerza de voluntad', 'Sin técnicas complicadas'];
  return <section className="relative min-h-0 md:min-h-[90vh] flex items-center pt-2 pb-2 md:pt-20 md:pb-16 overflow-hidden bg-night-900" data-id="element-95">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] md:w-[800px] md:h-[800px] bg-cta/10 rounded-full blur-[80px] md:blur-[120px] pointer-events-none" data-id="element-96" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-98">
          <motion.span initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-block bg-cta/20 border border-cta/40 text-cta px-3 py-0.5 rounded-full text-[11px] md:text-base font-semibold mb-1 md:mb-6" data-id="element-99">
            Para vos que no podés dormir bien
          </motion.span>

          <h1 className="text-[22px] sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-2 md:mb-10 text-white" data-id="element-100">
            No podés dormir porque tu cabeza no para. Eso tiene solución
          </h1>
        </motion.div>

        {/* Product mockup between headline and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex justify-center mx-auto mb-2 md:mb-10" data-id="element-101">
          <a href="#compra" className="block relative group" data-id="element-102">
            <div className="absolute inset-0 bg-cta/20 rounded-2xl blur-2xl transition-all duration-500 group-hover:bg-cta/30 group-hover:blur-3xl" data-id="element-103" />
            <img src="https://cdn.magicpatterns.com/uploads/arTVoPpi2pJgxxQxXqoa21/hf_20260424_044229_9a75a013-d7fb-4b88-88ff-058c68ef8c0f.png" alt="Apagá la Cabeza y Dormite - El Sistema Completo" loading="eager" decoding="async" className="relative z-10 max-h-[150px] sm:max-h-[220px] md:max-h-[350px] w-auto h-auto transition-transform duration-500 group-hover:-translate-y-2" data-id="element-104" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center" data-id="element-105">
          <p className="text-xs sm:text-lg md:text-xl text-gray-300 mb-2 md:mb-8 leading-snug max-w-2xl mx-auto" data-id="element-106">
            El sistema paso a paso para apagar pensamientos, relajar el cuerpo y
            dormirte.
          </p>

          <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-x-3 gap-y-1 md:gap-y-2 mb-3 md:mb-10 max-w-2xl mx-auto" data-id="element-107">
            {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + idx * 0.1
          }} className="flex items-center gap-1 md:gap-2 text-gray-200" data-id="element-108">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-5 md:h-5 text-accent-blue shrink-0" data-id="element-109" />
                <span className="text-[11px] md:text-base font-medium" data-id="element-110">
                  {bullet}
                </span>
              </motion.div>)}
          </div>

          <div className="space-y-1.5 md:space-y-4 max-w-xl mx-auto" data-id="element-111">
            <Button href="#compra" fullWidth className="text-center !py-2.5 md:!py-4 !text-sm md:!text-xl" data-id="element-112">
              ESTA NOCHE DUERMO
            </Button>
            <div className="flex flex-wrap justify-center gap-2 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-113">
              <span data-id="element-114">🔒 Pago seguro</span>
              <span data-id="element-115">·</span>
              <span data-id="element-116">Acceso instantáneo</span>
              <span data-id="element-117">·</span>
              <span data-id="element-118">PDF descargable</span>
              <span data-id="element-119">·</span>
              <span className="text-white" data-id="element-120">$19.990</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};